export const isLocalStorageAvailable = () => {
  try {
    localStorage.setItem('', '');
    localStorage.removeItem('');
    return true;
  } catch (_e) {
    return false;
  }
};

export const getLocalStorageItem = (key: string) => {
  try {
    if (!isLocalStorageAvailable()) return null;
    return JSON.parse(localStorage.getItem(key) ?? '');
  } catch (_e) {
    return null;
  }
};

export const setLocalStorageItem = <T>(key: string, value: T) => {
  try {
    if (!isLocalStorageAvailable()) return null;
    return localStorage.setItem(key, JSON.stringify(value));
  } catch (_e) {
    return null;
  }
};
export const removeLocalStorageItem = (key: string) => {
  try {
    if (!isLocalStorageAvailable()) return null;
    localStorage.removeItem(key);
    return;
  } catch (_e) {
    return null;
  }
};
